<template>
  <div class="tags-list-horizontal__container">
    <div class="tags-list-horizontal">
      <div class="tags-container" ref="tagsContainer" v-show="tags">
        <div
          v-for="(tag, index) in tags"
          :key="tag.text"
        >
          <Tag
            class="tag"
            v-if="getVisibility(index)"
            :tag="tag"
          />
        </div>
      </div>
      <div>
        <v-icon
          v-if="showEllipsis"
          class="pa-1 ml-1"
          @click.stop="showAllTags = !showAllTags"
        >
          more_horiz
        </v-icon>
      </div>
    </div>
    <TagsListVertical v-model="showAllTags" :tags="tags" />
  </div>
</template>

<script>
import Vue from 'vue';
import TagsListVertical from './TagsListVertical';
import Tag from './Tag';

const SHOW_ALL_TAGS_BUTTON_WIDTH = 36;

export default {
  name: 'TagsListHorizontal',
  components: {
    TagsListVertical,
    Tag,
  },
  props: {
    tags: {
      type: Array,
      default: undefined,
    },
  },
  data() {
    return {
      numToDisplay: undefined,
      tagSizes: [],
      maxWidth: 10,
      updating: false,
      showAllTags: false,
    };
  },
  computed: {
    showEllipsis() {
      return this.numToDisplay && this.tags && this.tags.length > this.numToDisplay;
    },
  },
  methods: {
    getVisibility(index) {
      if (!this.numToDisplay) return true;

      return index < this.numToDisplay;
    },
    async tagsContainer() {
      const maxTry = 4;

      let currentTry = 0;
      let container = this.$refs.tagsContainer;

      while (!container) {
        // eslint-disable-next-line
        await Vue.nextTick();
        currentTry += 1;
        container = this.$refs.tagsContainer;

        if (currentTry >= maxTry) {
          return container;
        }
      }

      return container;
    },
    async calculateTagsSize() {
      if (!this.tags) return this.tagSizes;

      const tagsContainer = await this.tagsContainer();
      if (!tagsContainer) return this.tagSizes;

      const tags = tagsContainer.children;

      return Array.from(tags).map(elem => elem.clientWidth);
    },
    async calculateMaxWidth() {
      if (!this.tags) return this.maxWidth;

      const tagsContainer = await this.tagsContainer();
      if (!tagsContainer) return this.maxWidth;

      const maxWidth = tagsContainer.parentNode.clientWidth - SHOW_ALL_TAGS_BUTTON_WIDTH;

      return maxWidth;
    },
    async updateNumToDisplay() {
      if (!this.tags) return;
      if (this.updating) return;

      this.updating = true;

      this.numToDisplay = undefined;

      await Vue.nextTick();

      this.tagSizes = await this.calculateTagsSize();
      this.maxWidth = await this.calculateMaxWidth();

      let totalWidth = 0;
      let numToDisplay = 0;

      this.tagSizes.forEach(size => {
        totalWidth += size;
        if (totalWidth < this.maxWidth) {
          numToDisplay += 1;
        }
      });
      this.numToDisplay = numToDisplay;

      if (this.numToDisplay === 0) {
        this.numToDisplay = 1;
      }

      this.updating = false;

      if (this.tags.length !== this.tagSizes.length) {
        // Probably not updated
        this.updateNumToDisplay();
      }
    },
  },
  created() {
    this.updateNumToDisplay();
  },
  watch: {
    tags() {
      this.updateNumToDisplay();
    },
  },
  mounted() {
    window.addEventListener('resize', this.updateNumToDisplay);
  },
  unmounted() {
    window.removeEventListener('resize', this.updateNumToDisplay);
  },
};
</script>
<style scoped>
.tags-list-horizontal__container {
  display: flex;
  flex-shrink: 1;
  min-width: 0;
}
.tags-list-horizontal {
  display: flex;
  flex-shrink: 1;
  flex-grow: 1;
  min-width: 0;
}
.tag {
  margin-right: 4px;
}
.tags-container {
  display: flex;
  align-items: center;
  overflow: hidden;
}
</style>
